import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  UNAUTHENTICATED_ENTRY,
  AUTH_PATH_PREFIX,
  URL_REDIRECT_KEY,
} from "../configs/AppConfig";
import { RootContext } from "../context/RootContext";

const ProtectedRoutes = () => {
  const { token } = useContext(RootContext);
  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PATH_PREFIX}${UNAUTHENTICATED_ENTRY}?${URL_REDIRECT_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoutes;
